import { useStyle } from "./style";
import { useIntl } from "react-intl";
import {
	Checkbox,
	CheckboxOnChangeData,
	Divider,
	Text,
	mergeClasses,
} from "@fluentui/react-components";
import { Flex, GapSize } from "@/components/atoms/flex";
import { AgentJoinedToProps } from "./types";
import { Desire } from "@/components/molecules/desire/Desire";
import { QueuesState, useQueuesStore } from "@/common/stores/nonpersistingStores/queues";
import { useMemo } from "react";

export const SupervisorAgentJoinedTo = (props: AgentJoinedToProps) => {
	const intl = useIntl();
	const classes = useStyle();
	const queues = useQueuesStore((state: QueuesState) => state.queues);

	const allAgentQueuesIds = new Set(props.queues.map((x) => x.id));
	const allReachableQueuesIds = new Set(queues.map((x) => x.id));

	const allCanJoinQueues = queues
		.filter((x) => x.isSupervisor && allAgentQueuesIds.has(x.id))
		.map((x) => x.id);

	const isAllJoinedChecked = useMemo(
		() =>
			props.queues.filter((q) => !q.isJoined && allCanJoinQueues.includes(q.id))
				.length == 0,
		[allCanJoinQueues, props.queues]
	);

	return (
		<Flex column gap={GapSize.Medium}>
			<Text className={classes.queuesTitle}>
				{intl.formatMessage({ id: "Supervisor.JoinToQueue" })}
			</Text>

			<Divider />

			<Flex vAlign="center" className={classes.joinAll}>
				<Checkbox
					label={intl.formatMessage({ id: "Supervisor.JoinAllQueues" })}
					checked={isAllJoinedChecked}
					className={classes.multiCheckboxItem}
					onChange={(_: any, data: CheckboxOnChangeData) => {
						props.onJoinAllChange(props.id, data.checked);
					}}
				/>
			</Flex>

			<Divider />

			<div
				className={mergeClasses(
					classes.queuesList,
					classes.queuesListContainer
				)}
			>
				<Flex column className={classes.multiCheckbox}>
					{props.queues
					.filter((x) => allReachableQueuesIds.has(x.id))
					.map((x) => {
						const currentQueue = queues.find((y) => y.id === x.id);
						const isDisabled =
							currentQueue?.hasAgentsActivityRight &&
							!currentQueue.isSupervisor;

						return (
							<Flex vAlign="center" key={`${x.agentId}-${x.id}`}>
								<Checkbox
									label={{ children: x.name, title: x.name }}
									checked={x.isJoined}
									disabled={isDisabled}
									className={classes.multiCheckboxItem}
									onChange={(_: any, data: CheckboxOnChangeData) =>
										props.onJoinChange(x, data.checked)
									}
								/>
								<Desire data={x} onChange={props.onDesireChange} />
							</Flex>
						);
					})}
				</Flex>
			</div>
		</Flex>
	);
};
